<template>
  <div>
    <app-page-container>
      <app-flex-grid :rows="[['150px', 1, 1, 1]]" align-items="flex-end">
        <template #col-1-1>
          <app-form-field label="Estimated price">
            <app-input :value="`${reservation.estimated_price.toLocaleString()} USD`" readonly />
          </app-form-field>
        </template>
        <template #col-1-2>
          <app-form-field label="Invoice amount" label-for="invoice_amount">
            <app-input
              v-model.number="reservation.invoice_amount"
              id="invoice_amount"
              type="number"
              min="0"
              placeholder="0"
              name="invoice_amount"
              readonly
            />
          </app-form-field>
        </template>
        <template #col-1-3>
          <app-form-field label="Invoice number" label-for="invoice_number">
            <app-input
              v-model="reservation.invoice_number"
              id="invoice_number"
              placeholder="Invoice number"
              name="invoice_number"
              readonly
            />
          </app-form-field>
        </template>
        <template #col-1-4>
          <app-form-field label="Invoice">
            <app-uploader
              v-model="reservation.invoice"
              class="custom-uploader--min-150"
              :extensions="['application/pdf', 'image/jpeg', 'image/png', 'image/tiff', 'image/bmp']"
              readonly
            />
          </app-form-field>
        </template>
      </app-flex-grid>
    </app-page-container>
  </div>
</template>

<script>
import { patchReservationsFlights } from '@/http'

export default {
  name: 'FlightsReservationsFinanceOld',
  props: {
    reservation: Object,
  },
  computed: {
    is_reservations_department() {
      return this.$store.state.userGroups.map(item => item.code).includes('reservation_manager')
        || this.$store.state.userGroups.map(item => item.code).includes('reservation_assistant')
        || this.$store.state.userGroups.map(item => item.code).includes('reservation_supervisor')
    },
    is_general_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager')
    },
  },
  methods: {
    onReservationPatch() {
      this.$refs.save_finance.preload = true
      patchReservationsFlights(
        this.$route.params.id,
        {
          invoice_amount: this.reservation.invoice_amount,
          invoice: this.reservation.invoice && this.reservation.invoice.id ? this.reservation.invoice.id : null,
          invoice_number: this.reservation.invoice_number,
        }
      )
        .finally(() => { this.$refs.save_finance.preload = false })
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Data saved',
          })
        })
    },
  }
}
</script>
